module.exports = __webpack_public_path__ + "media/favicons/android-chrome-192x192-cc8ce172.png";